export default {
	"commonText": {
		"cancel": "***Sapphire Cancel",
		"confirm": "***Sapphire Confirm",
		"dueSoonTextDescription": "***Sapphire Due today or tomorrow",
		"edit": "***Sapphire Edit",
		"parentAccountTestRestrictionMessage": "***Sapphire You must be logged in as a student to take a test.",
		"save": "***Sapphire Save",
		"title": "***Sapphire Title",
		"unauthorizedAccess": "***Sapphire Unauthorized Access",
		"SMSDisclosure":"*** Sapphire SMS Disclosure"
	},
	"MAIN_CONTENT": {
		"Accessibility": {
			"skipToMainContent": "***Sapphire Skip to main content",
			"opensInNewTab": "***Sapphire Opens in a new tab"
		},
		"Announcements": {
			"labelAnnouncements": "***Sapphire Announcements",
			"labelDistrictWideAnnouncement": "***Sapphire District-Wide Announcement",
			"labelLess": "***Sapphire Less",
			"labelMore": "***Sapphire More"
		},
		"App": {
			"genericErrorMessage": "***Sapphire Unable to complete data request. If issues persist, please contact support.",
			"permissionDeniedMessage": "***Sapphire Permission Denied. Account is not attached to any students.",
			"titleCWP": "***Sapphire Sapphire Community Portal"
		},
		"AssessmentScores": {
			"assessment": "***Sapphire Assessment",
			"date": "***Sapphire Date",
			"grade": "***Sapphire Grade",
			"noAssessmentsMessage": "***Sapphire No assessment information is available for this student.",
			"proficiency": "***Sapphire Proficiency",
			"proficient": "***Sapphire Proficient",
			"score": "***Sapphire Score",
			"sideMenuAssessmentScoresLink": "***Sapphire Assessment Scores"
		},
		"AssessmentScoresDetails": {
			"assessmentScoresWithColon": "***Sapphire Assessment Scores: {name}",
			"column": "***Sapphire Column",
			"columnDesc": "***Sapphire Column Desc",
			"score": "***Sapphire Score"
		},
		"AssignmentBin": {
			"attachedFiles": "***Sapphire Attached Files",
			"attachedFilesColon": "***Sapphire Attached Files:",
			"bytesMessage": "***Sapphire {name} ({size} Bytes)",
			"due": "***Sapphire Due: {date}",
			"gradeOverPoints": "***Sapphire {grade}/{points}",
			"hyphen": "***Sapphire  - ",
			"mySubmissions": "***Sapphire My Submissions",
			"noAssignmentsInAssignmentBin": "***Sapphire No assignments in assignment bin",
			"seeFeedback": "***Sapphire See Feedback"
		},
		"AssignmentsCarousel": {
			"classPage_dueSoon": "***Sapphire Due today or tomorrow ({count})",
			"reviewTestText": "***Sapphire Review Test",
			"takeTestText": "***Sapphire Take Test"
		},
		"Attendance": {
			"attendanceDescription": "***Sapphire Attendance Description",
			"count": "***Sapphire Count",
			"attendanceCodesCounts": "***Sapphire Attendance Codes Counts",
			"comments": "***Sapphire Comments",
			"date": "***Sapphire Date",
			"day": "***Sapphire Day",
			"Minutes": "***Sapphire Minutes",
			"noAbsenceRecords": "***Sapphire This student has no absences",
			"pendingForm": "***Sapphire Excuse Form Pending",
			"periodAttendance": "***Sapphire Period Attendance",
			"periodAttendanceCodes": "***Sapphire Period Attendance Codes",
			"periodAttendanceCodesIcon": "***Sapphire Show Period Attendance Codes Legend",
			"periodAttendanceCodesLegend": "***Sapphire Period Attendance Codes Legend",
			"periodTooltip": "***Sapphire {date} for period {period}: {code} - {description}",
			"selectMonthsToDisplay": "***Sapphire Select Months to Display",
			"showFullYearAllCaps": "***Sapphire Show Full Year",
			"sideMenuAttendanceLink": "***Sapphire Attendance",
			"submitAbsenceForm": "***Sapphire Submit Absence Excuse",
			"youDoNotHaveAccessToThisStudentWithPeriod": "***Sapphire You do not have access to this student."
		},
		"AttendanceSummary": {
			"absencesLabel": "***Sapphire Absences",
			"daysAllCaps": "***Sapphire DAYS",
			"daysAllLowercase": "***Sapphire days",
			"earlyAllCaps": "***Sapphire EARLY",
			"earlyAllLowercase": "***Sapphire early",
			"excusedWithColon": "***Sapphire Excused:",
			"minAllCaps": "***Sapphire MIN",
			"minAllLowercase": "***Sapphire min",
			"tardyAllCaps": "***Sapphire TARDY",
			"tardyAllLowercase": "***Sapphire tardy",
			"tardySlashEarlyDismissal": "***Sapphire Tardy / Early Dismissal",
			"unexcusedWithColon": "***Sapphire Unexcused:",
			"unlawfulWithColon": "***Sapphire Unlawful:"
		},
		"BuildingInformation": {
			"addressWithColon": "***Sapphire Address:",
			"buildingInformation": "***Sapphire Building Information",
			"faxWithColon": "***Sapphire Fax:",
			"phoneWithColon": "***Sapphire Phone:",
			"staffTitle": "***Sapphire {title}:"
		},
		"BusingDetails": {
			"blockWithColon": "***Sapphire Block:",
			"bussingNotesWithColon": "***Sapphire Busing Notes:",
			"bussingStatusWithColon": "***Sapphire Busing Status:",
			"busWithColon": "***Sapphire {period} Bus:",
			"carColorWithColon": "***Sapphire Car Color:",
			"carInformationWithColon": "***Sapphire Car Information:",
			"carNotesWithColon": "***Sapphire Car Notes:",
			"licensePlateWithColon": "***Sapphire License Plate:",
			"makeSlashModelWithColon": "***Sapphire Make/Model:",
			"parkingInformationWithColon": "***Sapphire Parking Information:",
			"permitWithColon": "***Sapphire Permit:",
			"stopWithColon": "***Sapphire Stop:",
			"streetWithColon": "***Sapphire Street:",
			"timeWithColon": "***Sapphire Time:",
			"zoneWithColon": "***Sapphire Zone:"
		},
		"Calendar": {
			"lunchMenuModalTitle": "***Sapphire {date} - {school} lunch menu."
		},
		"ChangeStudentData": {
			"addressCity": "***Sapphire Address City",
			"addressCounty": "***Sapphire Address County",
			"addressLineOne": "***Sapphire Address Line 1",
			"addressLineTwo": "***Sapphire Address Line 2",
			"birthDate": "***Sapphire Birth Date",
			"canSendTextMessages": "***Sapphire Can the school send text messages to the Student Phone number?",
			"canSendVoiceMessages": "***Sapphire Can the school send voice messages to the Student Phone number?",
			"contactLivesWithStudent": "***Sapphire Contact lives with the Student",
			"currentWithColon": "***Sapphire Current: {choice}",
			"emailAddressOne": "***Sapphire Email Address 1",
			"emailAddressThree": "***Sapphire Email Address 3",
			"emailAddressTwo": "***Sapphire Email Address 2",
			"employer": "***Sapphire Employer",
			"firstName": "***Sapphire First Name",
			"householdPhone": "***Sapphire Household Phone",
			"householdPhoneEmergencyCallOrder": "***Sapphire Household Phone Emergency Call Order",
			"isPhoneUnlisted": "***Sapphire Is the Student Phone number unlisted?",
			"lastName": "***Sapphire Last Name",
			"middleName": "***Sapphire Middle Name",
			"occupation": "***Sapphire Occupation",
			"parentsGuardians": "***Sapphire Parents/Guardians",
			"phoneFive": "***Sapphire Phone 5",
			"phoneFiveCanSendTextMessages": "***Sapphire Can the school send text messages to the Phone 5 number?",
			"phoneFiveCanSendVoiceMessages": "***Sapphire Can the school send voice messages to the Phone 5 number?",
			"phoneFiveEmergencyCallOrder": "***Sapphire Phone 5 Emergency Call Order",
			"phoneFiveExtension": "***Sapphire Phone 5 Extension",
			"phoneFiveNumberUnlisted": "***Sapphire Is the Phone 5 number unlisted?",
			"phoneFiveType": "***Sapphire Phone 5 Type",
			"phoneFour": "***Sapphire Phone 4",
			"phoneFourCanSendTextMessages": "***Sapphire Can the school send text messages to the Phone 4 number?",
			"phoneFourCanSendVoiceMessages": "***Sapphire Can the school send voice messages to the Phone 4 number?",
			"phoneFourEmergencyCallOrder": "***Sapphire Phone 4 Emergency Call Order",
			"phoneFourExtension": "***Sapphire Phone 4 Extension",
			"phoneFourNumberUnlisted": "***Sapphire Is the Phone 4 number unlisted?",
			"phoneFourType": "***Sapphire Phone 4 Type",
			"phoneOne": "***Sapphire Phone 1",
			"phoneOneCanSendTextMessages": "***Sapphire Can the school send text messages to the Phone 1 number?",
			"phoneOneCanSendVoiceMessages": "***Sapphire Can the school send voice messages to the Phone 1 number?",
			"phoneOneEmergencyCallOrder": "***Sapphire Phone 1 Emergency Call Order",
			"phoneOneExtension": "***Sapphire Phone 1 Extension",
			"phoneOneNumberUnlisted": "***Sapphire Is the Phone 1 number unlisted?",
			"phoneOneType": "***Sapphire Phone 1 Type",
			"phoneThree": "***Sapphire Phone 3",
			"phoneThreeCanSendTextMessages": "***Sapphire Can the school send text messages to the Phone 3 number?",
			"phoneThreeCanSendVoiceMessages": "***Sapphire Can the school send voice messages to the Phone 3 number?",
			"phoneThreeEmergencyCallOrder": "***Sapphire Phone 3 Emergency Call Order",
			"phoneThreeExtension": "***Sapphire Phone 3 Extension",
			"phoneThreeNumberUnlisted": "***Sapphire Is the Phone 3 number unlisted?",
			"phoneThreeType": "***Sapphire Phone 3 Type",
			"phoneTwo": "***Sapphire Phone 2",
			"phoneTwoCanSendTextMessages": "***Sapphire Can the school send text messages to the Phone 2 number?",
			"phoneTwoCanSendVoiceMessages": "***Sapphire Can the school send voice messages to the Phone 2 number?",
			"phoneTwoEmergencyCallOrder": "***Sapphire Phone 2 Emergency Call Order",
			"phoneTwoExtension": "***Sapphire Phone 2 Extension",
			"phoneTwoNumberUnlisted": "***Sapphire Is the Phone 2 number unlisted?",
			"phoneTwoType": "***Sapphire Phone 2 Type",
			"residentOfCounty": "***Sapphire Resident of County",
			"schoolNotificationMessage": "***Sapphire The school will be notified of any changes made and have a chance to review them before the changes take effect.",
			"sideMenuChangeStudentDataLink": "***Sapphire Change Student Data",
			"state": "***Sapphire State",
			"studentAddressCity": "***Sapphire Student Address City",
			"studentAddressLineOne": "***Sapphire Student Address Line 1",
			"studentAddressLineTwo": "***Sapphire Student Address Line 2",
			"studentAddressState": "***Sapphire Student Address State",
			"studentAddressZip": "***Sapphire Student Address Zip",
			"studentAddressZipExtend": "***Sapphire Student Address Extended Zip",
			"studentEmailAddress": "***Sapphire Student Email Address",
			"studentInformation": "***Sapphire Student Information",
			"studentPhone": "***Sapphire Student Phone",
			"studentPhoneType": "***Sapphire Student Phone Type",
			"title": "***Sapphire Title",
			"township": "***Sapphire Township",
			"zipCode": "***Sapphire Zip Code",
			"zipCodeExtension": "***Sapphire Zip Extension"
		},
		"ClassGlossary": {
			"glossary": "***Sapphire Glossary",
			"studentClassGlossaryTitleCase": "***Sapphire Student Class Glossary",
			"studentGroupGlossaryTitleCase": "***Sapphire Student Group Glossary"
		},
		"ClassGrades": {
				"assignmentDescription": "***Sapphire Assignment Description",
				"assignments": "***Sapphire Assignments",
				"assignmentsAllCaps": "***Sapphire ASSIGNMENTS",
				"categories": "***Sapphire CATEGORIES",
				"category": "***Sapphire Category",
				"classAverage": "***Sapphire Class Average",
				"codeOverPoints": "***Sapphire {code}/{points}",
				"codeOverPointsPercent": "***Sapphire {code}/{points} ({percent})",
				"currentGrade": "***Sapphire Current Grade:",
				"currentGradeTitleCase": "***Sapphire Current Grade",
				"currentOverMaxPoints": "***Sapphire {current} / {max}",
				"date": "***Sapphire Date",
				"dateAssigned": "***Sapphire Date Assigned",
				"dateDue": "***Sapphire Date Due",
				"finalAverageNote": "***Sapphire *Total points over possible points may not reflect the student's final average if the teacher sets categories to be a specific percentage of a student's marking period average.",
				"generalComment": "***Sapphire General Comment",
				"grade": "***Sapphire Grade",
				"gradesOverPointsAsterisk": "***Sapphire {grade} / {points}*",
				"markingPeriod": "***Sapphire Marking Period: {code}",
				"markingPeriodAbbreviation": "***Sapphire MP %",
				"maxExtraCredit": "***Sapphire Max Extra Credit",
				"noAssignmentGrades": "***Sapphire This marking period currently does not have any assignments with grades.",
				"noCategoryGrades": "***Sapphire This marking period currently does not have any categories with grades.",
				"percent": "***Sapphire {percent}%",
				"points": "***Sapphire Points:",
				"scoresHigher": "***Sapphire Scores Higher",
				"scoresLower": "***Sapphire Scores Lower",
				"scoresSame": "***Sapphire Scores Same",
				"showBy": "***Sapphire Show by:",
				"skill": "***Sapphire Skill",
				"teacherComments": "***Sapphire Teacher Comments",
				"viewAssignmentTest": "***Sapphire View Assignment/Test",
				"weight": "***Sapphire Weight"
		},
		"classPage": {
				"AssignmentCarousel": {
						"classPage_due": "***Sapphire Due:",
						"classPage_noDueDate": "***Sapphire No due date",
						"classPage_points": "***Sapphire Points",
						"classPage_pointsWithPoints": "***Sapphire {points} Points",
						"classPage_testClosesAt": "***Sapphire Test closes at {time}",
						"classPage_uploadSubmission": "***Sapphire Upload Submission"
				},
				"AssignmentsList": {
						"classPage_action": "***Sapphire Action",
						"classPage_assignmentName": "***Sapphire Assignment Name",
						"classPage_dueDate": "***Sapphire Due Date"
				},
				"ClassItems": {
					"noFilesMessage": "***Sapphire Currently, there are no files in this folder."
				},
				"ClassNav": {
					"classPage_classHome": "***Sapphire Class Home"
				},
				"Header": {
					"classPage_classMenu": "***Sapphire Class Menu",
					"teacherEmail": "***Sapphire e-mail {teacher}"
				},
				"index": {
					"classPage_courseInfo": "***Sapphire Course Info",
					"classPage_courseSections": "***Sapphire Subsection",
					"classPage_currentGrades": "***Sapphire Current Grades",
					"classPage_gridView": "***Sapphire Grid View",
					"classPage_listView": "***Sapphire List View",
					"classPage_reportsForStudent": "***Sapphire Postings For {student}",
					"classPage_sliderView": "***Sapphire Slider View"
				}
		},
		"commonContent": {
			"attachFile": "***Sapphire Attach a file",
			"attachFiles": "***Sapphire Attach files",
			"classPage_upcomingAssignments": "***Sapphire Upcoming Assignments",
			"classPage_upcomingAssignmentTotal": "***Sapphire total ({count})",
			"closeButton": "***Sapphire Close",
			"currentHeaderLabel": "***Sapphire (current)",
			"definition": "***Sapphire Definition",
			"dropMultipleFiles": "***Sapphire Drop files here to upload",
			"dropSingleFile": "***Sapphire Drop a file here to upload",
			"goBack": "***Sapphire Go Back",
			"homeHeaderLink": "***Sapphire Home",
			"invalidPermissions": "***Sapphire You do not have permission to access this page.",
			"name": "***Sapphire Name",
			"newEntryTitleCase": "***Sapphire New Entry",
			"newEntryTitleCaseWithIcon": "***Sapphire <i class=\"fas fa-plus\"></i> New Entry",
			"newPosts": "***Sapphire New Posts",
			"next": "***Sapphire Next",
			"noLabel": "***Sapphire No",
			"noStudentHasBeenSelectedWithPeriod": "***Sapphire No student has been selected.",
			"previous": "***Sapphire Previous",
			"remove": "***Sapphire Remove",
			"schoolLabel": "***Sapphire School",
			"score": "***Sapphire Score:",
			"selectMultipleFiles": "***Sapphire Select files to upload",
			"selectSingleFile": "***Sapphire Select a file to upload",
			"sideMenuGradeLabel": "***Sapphire Grade:",
			"size": "***Sapphire Size",
			"submit": "***Sapphire Submit",
			"submitButton": "***Sapphire Submit",
			"term": "***Sapphire Term",
			"yesLabel": "***Sapphire Yes"
		},
		"confirmSubmission": {
			"confirmSubmission_submitMessage": "***Sapphire Please click the Submit button below to save any question in progress.",
			"confirmSubmission_timesUp": "***Sapphire Sorry, time's up!",
			"pleaseConfirm": "***Sapphire Please Confirm...",
			"returnToQuestionLink": "***Sapphire Use the <a href=\"#question-nav\">question selection menu</a> to return to a question.",
			"returnToQuestionLinkBegin": "***Sapphire Use the ",
			"returnToQuestionLinkEnd": "***Sapphire  to return to a question.",
			"returnToQuestionLinkMiddle": "***Sapphire question selection menu",
			"takeTester_answersNotSaved": "***Sapphire {count} answer(s) not yet saved! You can revisit and save your answers or by submitting the test all unsaved answers will be saved.",
			"takeTester_extraCreditUnanswered": "***Sapphire {count} extra credit question(s) unanswered!",
			"takeTester_itAppearsThatYouHave": "***Sapphire It appears that you have:",
			"takeTester_questionsUnanswered": "***Sapphire {count} question(s) unanswered!",
			"takeTester_readyToSubmit": "***Sapphire If you are ready to submit your test, click the button below.",
			"takeTester_singleSittingMessage": "***Sapphire Once you submit your test, you will not be able to change any answers!"
		},
		"CourseRequestForms": {
			"actions": "***Sapphire Actions",
			"chooseDesiredCourseInParenthese": "***Sapphire (Choose if the desired class is not on this list)",
			"courseNonRepeat": "***Sapphire *Student has already taken this course.",
			"coursePreAssigned": "***Sapphire *This course was pre-assigned and cannot be deselected.",
			"courseRequestFormInstructionStepEight": "***Sapphire Print 2 copies of the Course Selection Form, 1 for your records and 1 for the school.",
			"courseRequestFormInstructionStepFive": "***Sapphire To view \"Electives\", Click on the \"Expand\" button to open the screen and select the courses of interest. If you want an alternative course to the one/s you selected you may click to the right of the course of interest in the column labeled \"alternate\". You may then \"collapse\" the screen when finished and move to another area.",
			"courseRequestFormInstructionStepFour": "***Sapphire \"Mandatory Courses\", will be selected for you at your next grade level.",
			"courseRequestFormInstructionStepNine": "***Sapphire Return the signed school copy to your school",
			"courseRequestFormInstructionStepOne": "***Sapphire Choose the appropriate Grade Level above and click \"Fill Out Course Selection\".",
			"courseRequestFormInstructionStepSeven": "***Sapphire On the resulting Course Request Form check for accuracy and follow any remaining instructions.",
			"courseRequestFormInstructionStepSix": "***Sapphire When you have completed your selections, click on \"Save Course Selection.\"",
			"courseRequestFormInstructionStepThree": "***Sapphire All students must select one course from each of the required disciplines.",
			"courseRequestFormInstructionStepTwo": "***Sapphire Select your courses by clicking in the appropriate boxes. If you make a mistake you can simply deselect the check mark next to the course that you want to delete.",
			"courseTitle": "***Sapphire Course Title",
			"credits": "***Sapphire Credits",
			"creditsWithColon": "***Sapphire Credits: {count}",
			"electiveCourses": "***Sapphire Elective Courses",
			"failedPrerequisites": "***Sapphire *Student has not fulfilled the prerequisites of this course.",
			"fillOutCourseRequestForm": "***Sapphire Fill out course request form",
			"mandatoryCourses": "***Sapphire Mandatory Courses",
			"maximumRequirementsMet": "***Sapphire Maximum credits requirement has been reached. A maximum of {max} credits are allowed. Currently {total} credits have been requested.",
			"minimumCreditsNotMet": "***Sapphire Minimum credits requirement has not been reached. A minimum of {min} credits are allowed. Currently {total} credits have been requested.",
			"moreDetailWithColon": "***Sapphire More Detail:",
			"rankAlternateCouses": "***Sapphire {courseid} - {coursedescription}",
			"rankAlternates": "***Sapphire Rank Alternates",
			"rankAlternatesCredits": "***Sapphire Credits: {credit}",
			"rankAlternatesInstructions": "***Sapphire Use the arrows to sort your preferences for courses. 1 indicates your first choice, 2 second, and so on.",
			"rankAlternatesRank": "***Sapphire {rank}",
			"requiredCourses": "***Sapphire Required Courses",
			"selectCourseRequestForm": "***Sapphire Select Course Request Form",
			"selectCourseRequestFormToComplete": "***Sapphire Select the course request form you wish to complete from the list below.",
			"specialRequestNotes": "***Sapphire Special Request Notes"
		},
		"CoursesAndGradesList": {
			"courseTitle": "***Sapphire Course Title",
			"currentGrade": "***Sapphire Current Grade",
			"duration": "***Sapphire Dur.",
			"periodDays": "***Sapphire Per.(Days)",
			"room": "***Sapphire Room",
			"showNonHyphenGradeClasses": "***Sapphire Show Non-Graded Classes",
			"sideMenuCoursesAndGradesLink": "***Sapphire Courses & Grades",
			"teacher": "***Sapphire Teacher"
		},
		"CurrentSchedule": {
			"rm": "***Sapphire RM",
			"showColorTitleCase": "***Sapphire Show Color",
			"showCourseSectionTitleCase": "***Sapphire Show Course Section",
			"showCourseTimesTitleCase": "***Sapphire Show Course Times",
			"sideMenuCurrentScheduleLink": "***Sapphire Current Schedule"
		},
		"DataForm": {
			"absenceDate": "***SapphireAbsence Date",
			"absenceDateFrom": "***SapphireAbsence Date From",
			"absenceDateTo": "***SapphireAbsence Date To",
			"absenceReason": "***SapphireReason for Absence",
			"addressOne": "***Sapphire Address 1",
			"addressTwo": "***Sapphire Address 2",
			"attachDocuments": "***SapphireAttach Documents",
			"attachmentWithColon": "***Sapphire Attachment:",
			"back": "***Sapphire Back",
			"cellPhone": "***Sapphire Cell Phone",
			"city": "***Sapphire City",
			"contactLivesWithStudent": "***Sapphire Contact Lives With Student",
			"county": "***Sapphire County",
			"currentStepOfTotal": "***Sapphire Step {current} of {total}",
			"dirtyPageCancelText": "***Sapphire Keep Filling Out Form",
			"dirtyPageMessage": "***Sapphire The form has been modified. Are you sure you want to leave without saving changes?",
			"dirtyPageOkText": "***Sapphire Leave Without Saving",
			"dirtyPageTitle": "***Sapphire Unsaved Changes",
			"datePickerMessage": "***Sapphire {field} Date Picker",
			"email": "***Sapphire Email",
			"emergencyCallOrder": "***Sapphire Emergency Call Order",
			"employer": "***Sapphire Employer",
			"ext": "***Sapphire Ext.",
			"faxNumber": "***Sapphire Fax Number",
			"formSubmitted": "***Sapphire Form Submitted!",
			"groupNumber": "***Sapphire Group Number",
			"homePhone": "***Sapphire Home Phone",
			"hospitalPreference": "***Sapphire Hospital Preference",
			"idNumber": "***Sapphire ID Number",
			"insuranceCompany": "***Sapphire Insurance Company",
			"middleName": "***Sapphire Middle Name",
			"number": "***Sapphire Number",
			"occupation": "***Sapphire Occupation",
			"pageNumber": "***Sapphire Pager Number",
			"phoneNumberExtension": "***Sapphire Phone Number Extension",
			"physicianFax": "***Sapphire Physician Fax",
			"physicianFaxExtension": "***Sapphire Physician Fax Extension",
			"physicianFaxNumber": "***Sapphire Physician Fax Number",
			"physicianName": "***Sapphire Physician Name",
			"physicianPhone": "***Sapphire Physician Phone",
			"policyNumber": "***Sapphire Policy Number",
			"receivesVoiceCalls": "***Sapphire Receives Voice Calls",
			"releaseStatus": "***Sapphire Release Status",
			"saveCurrentProgressTitleCase": "***Sapphire Save Current Progress",
			"selectDates": "***Sapphire Select the dates that apply",
			"state": "***Sapphire State",
			"stepNumber": "***Sapphire {str}",
			"successfullySubmitted": "***Sapphire You have successfully submitted the following form",
			"test": "***Sapphire {description}",
			"title": "***Sapphire Title",
			"titleWithFormName": "***Sapphire Student Data Forms - {title}",
			"township": "***Sapphire Township",
			"type": "***Sapphire Type",
			"unlisted": "***Sapphire Unlisted",
			"uploadFilesTitleCase": "***Sapphire Uploaded Files",
			"workPhone": "***Sapphire Work Phone",
			"zipCode": "***Sapphire Zip Code",
			"zipCodeExt": "***Sapphire Zip Code Ext",
			"zipCodeExtension": "***Sapphire Zip code extension"
		},
		"Devices": {
			"activeSince": "***Sapphire Active Since",
			"confirmLogoutMessage": "***Sapphire Are you sure you want to log out of this device?",
			"confirmLogoutTitle": "***Sapphire Log out of this device?",
			"device": "***Sapphire Device",
			"devices": "***Sapphire Devices",
			"devicesDescription1Part1": "***Sapphire You have used the ",
			"devicesDescription1Part2": "***Sapphire option on the Sapphire Login screen and are currently logged in on the devices below. You will remain logged in until you log out of Sapphire on this device.",
			"devicesDescription2": "***Sapphire Some devices and browsers have default settings that might automatically log you out. If you experience unintended logouts, please check your device or browser settings.",
			"lastUsed": "***Sapphire Last Used",
			"lastUsedAt": "***Sapphire Last Used at",
			"logOutDevice": "***Sapphire Log Out Device",
			"manageDevices": "***Sapphire Manage My Logged in Devices",
			"noDevicesMessage": "***Sapphire You currently have no devices logged in with the 'remember me?' option selected.",
			"RememberMe": "***Sapphire Remember me?"
		},
		"Discipline": {
			"actionTaken": "***Sapphire Actions Taken",
			"date": "***Sapphire Date",
			"description": "***Sapphire Description",
			"incidentModalTitle": "***Sapphire {description} Incident - Official Description",
			"infractions": "***Sapphire Infractions",
			"noIncidents": "***Sapphire No incidents to show.",
			"showDescription": "***Sapphire Show Description",
			"sideMenuDisciplineLink": "***Sapphire Discipline"
		},
		"Elective": {
			"alternate": "***Sapphire Alternate",
			"electiveAriaMessage": "***Sapphire Course {title} - Credits: {credits}",
			"electiveAlternateAriaMessage": "***Sapphire Course {title} - Credits: {credits} Alternate",
			"specialAriaMessage": "Special Request"
		},
		"EssayQuestion": {
			"enterYourAnswer": "***Sapphire Enter your answer",
			"minMaxPointsMessage": "***Sapphire Please enter between {min} and {max} characters."
		},
		"Feedback": {
			"feedback": "***Sapphire Feedback",
			"noFeedbackMessage": "***Sapphire Currently no feedback for this assignment."
		},
		"Fees": {
			"balanceOwed": "***Sapphire Balance Owed",
			"balanceOwedToSchoolLabel": "***Sapphire Balance Owed to School: {fee}",
			"date": "***Sapphire Date",
			"fee": "***Sapphire Fee",
			"payment": "***Sapphire Payment",
			"sideMenuFeesLink": "***Sapphire Fees",
			"type": "***Sapphire Type"
		},
		"FileCabinet": {
			"navPanelFileCabinet": "***Sapphire File Cabinet",
			"navPanelReportsSubMenuFileCabinet": "***Sapphire Reports, Sub-Menu File Cabinet",
			"searchReturnedNoResults": "***Sapphire The search returned no results."
		},
		"FilesList": {
			"datePosted": "***Sapphire Date Posted",
			"name": "***Sapphire Name"
		},
		"Forum": {
			"message": "***Sapphire Message",
			"newTopic": "***Sapphire New Topic",
			"noTopicsMessage": "***Sapphire There are currently no topics for this forum.",
			"topicHeader": "***Sapphire {label}:"
		},
		"General": {
			"changeMyAccountSettings": "***Sapphire Change My Account Settings",
			"changeMyPassword": "***Sapphire Change my Password",
			"changeMyPasswordForced": "***Sapphire Your password was reset. Enter your temporary password from your email and your new password to continue.",
			"changeMySecurityQuestion": "***Sapphire Change my security question",
			"confirmNewPasswordStartCaseWithColon": "***Sapphire Confirm New Password:",
			"general": "***Sapphire General",
			"generalAccountSettings": "***Sapphire General Account Settings",
			"languageSelectionTitle": "***Sapphire Select a Language",
			"newPasswordStartCaseWithColon": "***Sapphire New Password:",
			"oldPasswordStartCaseWithColon": "***Sapphire Old Password:",
			"passwordDoesntMatch": "***Sapphire Confirm password does not match",
			"passwordLengthMessage": "***Sapphire At least {length} characters - the more characters, the better.",
			"passwordMixMessage": "***Sapphire A mixture of letters and numbers.",
			"passwordRequirements": "***Sapphire Password must must have the following characteristics: ",
			"passwordSettingsStartCase": "***Sapphire Password Settings",
			"pinWithColon": "***Sapphire PIN:",
			"securityAnswerStartCaseWithColon": "***Sapphire Security Answer:",
			"securityQuestionSettingsStartCase": "***Sapphire Security Question Settings",
			"securityQuestionStartCaseWithColon": "***Sapphire Security Question:",
			"selectLanguage": "***Sapphire Select Language:"
		},
		"GlossaryIndex": {
			"collapseAllTitleCase": "***Sapphire Collapse All",
			"expandAllTitleCase": "***Sapphire Expand All"
		},
		"GlossaryResults": {
			"attachedFilesTitleCase": "***Sapphire Attached Files",
			"authorWithColon": "***Sapphire Author:",
			"awaitingTeacherApproval": "***Sapphire Awaiting teacher approval.",
			"delete": "***Sapphire Delete",
			"edit": "***Sapphire Edit",
			"editTerm": "***Sapphire Edit-{term}",
			"teacherNote": "***Sapphire Teacher Note"
		},
		"GlossarySearch": {
			"hideAllTotalEntries": "***Sapphire Hide all {count} entries",
			"searchTermsTitleCase": "***Sapphire Search Terms",
			"viewAllTotalEntries": "***Sapphire View all {count} entries"
		},
		"GraduationProgressReport": {
			"course": "***Sapphire Course",
			"credits": "***Sapphire Credits",
			"creditsAllCaps": "***Sapphire CREDITS",
			"creditsEarned": "***Sapphire Credits Earned",
			"creditsInProgress": "***Sapphire Credits In-Progress",
			"creditsRequiredWithColon": "***Sapphire Credits Required:",
			"creditsStillNeededFirstLettersCapatilized": "***Sapphire Credits Still Needed",
			"departmentRequirementsSatisfiedUponCompletion": "***Sapphire Requirement satisfied upon successful completion of In-progress course work.",
			"finalGrade": "***Sapphire Final Grade",
			"grade": "***Sapphire Grade",
			"requirementHasBeenSatisfiedWithPeriod": "***Sapphire This Requirement Has Been Satisfied.",
			"sideMenuGraduationProgressLink": "***Sapphire Graduation Progress",
			"summary": "***Sapphire Summary",
			"totalCreditsNeededWithColon": "***Sapphire Total Credits Needed: {credits}",
			"totalCreditsRequirement": "***Sapphire Total Credits Requirement",
			"year": "***Sapphire Year"
		},
		"Header": {
			"account": "***Sapphire Account",
			"accountNavLabel": "***Sapphire Account",
			"accountSettingsHeaderLabel": "***Sapphire Account Settings",
			"changeLanguage": "***Sapphire Change Language",
			"currentStudentProfileTitleCase": "***Sapphire Current Student Profile",
			"logoutHeaderLabel": "***Sapphire Log Out",
			"myStudentProfileTitleCase": "***Sapphire My Student Profile",
			"selectAStudent": "***Sapphire Select a Student",
			"sideNavMyStudents": "***Sapphire My Students",
			"studentSelectionNavLabel": "***Sapphire Student Selection",
			"switchToParentView": "***Sapphire Switch to Parent View",
			"switchToStudentView": "***Sapphire Switch to Student View"
		},
		"HelpButton": {
			"clickLinkMessage": "***Sapphire Click link below to continue to help center",
			"goToHelp": "***Sapphire Go to Help Center",
			"helpLink": "***Sapphire Help",
			"note": "***Sapphire Note: To prevent this for next time, please make sure that pop-ups are allowed for Sapphire.",
			"popupBlocked": "***Sapphire Pop-up Blocker Detected."
		},
		"HomePage": {
			"actionsTakenLabel": "***Sapphire Actions Taken",
			"attendanceDescriptionLabel": "***Sapphire Attendance Description",
			"balanceOwedToSchoolLabelNoProp": "***Sapphire Balance Owed: ",
			"classLabel": "***Sapphire Class",
			"commentsLabel": "***Sapphire Comments",
			"completed": "***Sapphire {percent} Completed",
			"CovidSurveyMessage": "***Sapphire If you have not done so today, please fill in the ",
			"dateLabel": "***Sapphire Date",
			"dayLabel": "***Sapphire Day",
			"feesLabel": "***Sapphire Fees",
			"formsAwaitingCompletionLabel": "***Sapphire Forms Awaiting Completion",
			"formStarted": "***Sapphire (Form Started)",
			"gradeMarkingPeriodLabel": "***Sapphire Grade Marking Period",
			"graduationProgressLabel": "***Sapphire Graduation Progress",
			"infractionsLabel": "***Sapphire Infractions",
			"inProgress": "***Sapphire {percent} In Progress",
			"interactiveSchedulesLabel": "***Sapphire Interactive Schedules",
			"itemLabel": "***Sapphire Item",
			"localeSaveError": "***Sapphire Error while saving locale option.",
			"lunchMenuLabel": "***Sapphire Lunch Menu",
			"minutesLabel": "***Sapphire Minutes",
			"nextYearCourseRequestFormButton": "***Sapphire Next Year Course Request Form is Available",
			"noAttendanceFromPastSevenDaysLabel": "***Sapphire No attendance from past 7 days.",
			"noDisciplineFromThePastSevenDays": "***Sapphire No discipline from past 7 days.",
			"noGradeUpdatesFromThePastSevenDays": "***Sapphire No grade updates from past 7 days",
			"nothingForThisWeek": "***Sapphire Nothing for this week.",
			"noTransactionsFromThePastSevenDaysLabel": "***Sapphire No transactions from past 7 days.",
			"paymentsLabel": "***Sapphire Payments",
			"postedLabel": "***Sapphire Posted",
			"recentAttendanceLabel": "***Sapphire Recent Attendance",
			"recentClassPostingsLabel": "***Sapphire Recent Class Postings",
			"recentDisciplineLabel": "***Sapphire Recent Discipline",
			"recentFeesLabel": "***Sapphire Recent Fees",
			"recentGradeUpdatesLabel": "***Sapphire Recent Grade Updates",
			"recentSchoolPostingsLabel": "***Sapphire Recent School Postings",
			"seeAllLabel": "***Sapphire See All",
			"showingAttendanceFromPastSevenDaysLabel": "***Sapphire Showing attendance from past 7 days.",
			"showingDisciplineFromThePastSevenDays": "***Sapphire Showing discipline from past 7 days.",
			"showingGradeUpdatesFromThePastSevenDays": "***Sapphire Showing grade updates from past 7 days",
			"showingLabel": "***Sapphire Showing",
			"showingTransactionsFromThePastSevenDaysLabel": "***Sapphire Showing transactions from past 7 days.",
			"teacherLabel": "***Sapphire Teacher",
			"transactionsLabel": "***Sapphire Transactions",
			"typeLabel": "***Sapphire Type",
			"upcomingAssignments": "Upcoming Assignments",
			"updatedLabel": "***Sapphire Updated",
			"windowOpenUntilLabel": "***Sapphire Window Open Until"
		},
		"IncompleteForms": {
			"clearFormStartCase": "***Sapphire Clear Form",
			"formsAwaitingCompletionTitleCase": "***Sapphire Forms Awaiting Completion"
		},
		"InteractiveScheduler": {
			"allDepartments": "***Sapphire All Departments",
			"courseConflictMessage": "***Sapphire Oops... it appears your selected course conflicts with another course!",
			"confirmAddClassMessage": "***Sapphire Are you sure you wish to add this class?",
			"confirmAddClassOkText": "***Sapphire Add Class",
			"confirmAddClassTitle": "***Sapphire Add Class?",
			"empty": "***Sapphire (empty)",
			"filterBy": "***Sapphire Filter by:",
			"loadingMessage": "***Sapphire Loading schedule configuration...",
			"periodDays": "***Sapphire Periods / Days",
			"print": "***Sapphire Print",
			"schedulingConflictTitle": "***Sapphire Scheduling Conflict",
			"schedulingConflictMessage": "***Sapphire Class could not be added.",
			"selectScheduleToAccess": "***Sapphire Select which schedule you wish to access.",
			"showCourseDesctions": "***Sapphire Show Course Descriptions",
			"showUnavailableClasses": "***Sapphire Show Unavailable Classes",
			"sideMenuInteractiveSchedulerLink": "***Sapphire Interactive Scheduler",
			"useThisScreenToChangeClassSchedule": "***Sapphire Use this screen to make changes to your class schedule."
		},
		"LTILaunch": {
			"go": "***Sapphire Go"
		},
		"LunchMenus": {
			"lunchMenusLabel": "***Sapphire Lunch Menus"
		},
		"MatchingQuestion": {
			"correctAnswer": "***Sapphire Correct Answer:",
			"instruction": "***Sapphire Match each prompt with it's correct answer.",
			"pointsPossible": "***Sapphire {points} pts possible",
		},
		"MultipleChoiceQuestion": {
			"incorrectMessage": "***Sapphire Incorrect answers will take points away!",
			"pointsPossible": "***Sapphire {points} pts possible",
			"selectAllMessage": "***Sapphire Select ALL correct answers.",
			"selectCorrectMessage": "***Sapphire Select the correct answer."
		},
		"Notifications": {
			"addEmail": "***Sapphire Add email",
			"addNewStep": "***Sapphire Add new step",
			"addSMSTextMessage": "***Sapphire Add SMS Text Message",
			"addVoiceCall": "***Sapphire Add Voice Call",
			"answeredBy": "***Sapphire Answered by:",
			"broadcastHistoryText": "***Sapphire Broadcast History",
			"broadcastsTabName": "***Sapphire My Broadcast History",
			"contactAt": "***Sapphire Contact at",
			"custom": "***Sapphire Custom:",
			"customMessage": "***Sapphire Workflow is customized per subscription type, if no workflow is supplied the system will fall back to the user's default and then the system default.",
			"defaultEmailText": "***Sapphire Default Email Message Language:",
			"defaultNotifications": "***Sapphire Default Notification Workflow",
			"defaultSMSText": "***Sapphire Default SMS Text Language:",
			"defaultVoiceText": "***Sapphire Default Voice Call Language:",
			"dirtyPageCancelText": "***Sapphire Keep Editing",
			"dirtyPageMessage": "***Sapphire One or more changes have not been saved. Are you sure you want to leave without saving?",
			"dirtyPageOkText": "***Sapphire Leave Without Saving",
			"dirtyPageTitle": "***Sapphire Unsaved Changes",
			"districtAnnouncements": "***Sapphire District/School Announcements",
			"duration": "***Sapphire Duration:",
			"email": "***Sapphire Email",
			"emailAllCaps": "***Sapphire EMAIL",
			"emailWithColon": "***Sapphire Email:",
			"globalSetting": "***Sapphire Global Setting",
			"languageSettings": "***Sapphire Language Settings",
			"myDefault": "***Sapphire My Default:",
			"myDefaultMessageText": "***Sapphire Workflow is based on user defined default subscription workflow.",
			"noAudioSupport": "***Sapphire Your browser does not support the audio element.",
			"noBroadcastMessage": "***Sapphire No Broadcasts were found within the last 3 months",
			"notifications": "***Sapphire Notifications",
			"notificationsTabName": "***Sapphire Notification Workflow",
			"notificationsText": "***Sapphire Sapphire Notifications Subscriptions",
			"phone": "***Sapphire Phone:",
			"phoneMessage": "***Sapphire Phone Message:",
			"receiveNotificationsForTheFollowing": "***Sapphire Receive an Email Notification when the following items are posted:",
			"showEnglish": "***Sapphire Show English",
			"sms": "***Sapphire SMS",
			"smsTextMessage": "***Sapphire SMS Text Message",
			"smsTextMessageWithColon": "***Sapphire SMS Text Message:",
			"studentClassReports": "***Sapphire Student/Class Reports",
			"subjectLineWithColon": "***Sapphire Subject Line:",
			"subscribed": "***Sapphire Subscribed",
			"systemDefault": "***Sapphire System Default:",
			"systemDefaultMessageText": "***Sapphire Workflow is based off of Sapphire's system default workflow setting.",
			"turnOffNotificationsViaEmail": "***Sapphire Turn on and off the notifications via email",
			"voiceCall": "***Sapphire Voice Call"
		},
		"NumericQuestion": {
			"acceptableAnswers": "***Sapphire Acceptable Answer(s):",
			"instructionMessage": "***Sapphire Enter your numeric answer",
			"numericalLabel": "***Sapphire {first} - {second}",
			"points": "***Sapphire {points} points"
		},
		"ParentHomePage": {
			"emailWithColon": "***Sapphire Email:",
			"goToMyBackpack": "***Sapphire Go to My Backpack for {name}",
			"homePhoneNumberTitleCaseWithColon": "***Sapphire Home Phone Number:",
			"myStudents": "***Sapphire My Students",
			"quickViewTitleCase": "***Sapphire Quick View",
			"schoolContactTitleCaseWithColon": "***Sapphire School Contact:"
		},
		"PaymentPortal": {
			"adminMessage": "***Sapphire Administrators can view payment screens but cannot make payments. Payments must be made through either a parent or student account.",
			"amount": "***Sapphire Amount",
			"back": "***Sapphire Back",
			"balance": "***Sapphire Balance",
			"balanceZero": "***Sapphire Your balance is currently 0. Choose to pay another amount greater than 0.",
			"cardExpiration": "***Sapphire Card expiration",
			"choosePaymentTo": "***Sapphire Choose Payment To",
			"choosePaymentAmount": "***Sapphire Choose Payment Amount",
			"confirmPayment": "***Sapphire I acknowledge a payment of {amount} will be submitted through Vanco Payments.",
			"creditDebitCard": "***Sapphire Credit or debit card",
			"date": "***Sapphire Date",
			"fullNameOnCreditCard": "***Sapphire Full Name on Credit Card",
			"ID": "***Sapphire ID",
			"legalNotice": "***Sapphire Please note: All payments are processed through Vanco's payment services. Please contact school district for any questions regarding payments.",
			"legalNoticeContact": "***Sapphire Contact Information",
			"legalNoticeFooter": "***Sapphire All payments are being processed by Vanco Payment Services. This external payment system is a third-party owned and operated system and has its own privacy policies and terms of use. SapphireK12 is not responsible for supporting that system in any way. Kindly contact your school district if experiencing any difficulties in processing your payments. Please refer to the Sapphire Website for further details regarding this relationship.",
			"nextPaymentInformation": "***Sapphire Next: Payment Information",
			"otherAmount": "***Sapphire Other",
			"otherAmountBlank": "***Sapphire You must enter a value when paying other amount",
			"otherAmountGreaterThanBalance": "***Sapphire Warning you are paying amount greater than your balance. If you wish pay this amount continue to payment information screen.",
			"otherAmountZero": "***Sapphire You must enter an amount greater than 0.",
			"paymentDetails": "***Sapphire Payment Details",
			"paymentError": "***Sapphire Payment Error!",
			"paymentInformation": "***Sapphire Payment Information",
			"paymentProcessing": "***Sapphire Payment Processing",
			"paymentSuccessful": "***Sapphire Payment Successful!",
			"receiptEmailedTo": "***Sapphire Receipt Emailed To",
			"reference": "***Sapphire Reference",
			"school": "***Sapphire School",
			"submitPayment": "***Sapphire Submit Payment",
			"vancoPaymentPortal": "***Sapphire Payment Portal",
			"zipCode": "***Sapphire Zip Code"
		},
		"Post": {
			"backToTopics": "***Sapphire Back To Topics",
			"comment": "***Sapphire Comment",
			"editPost": "***Sapphire Edit Post",
			"forumLoadedAt": "***Sapphire Forum last refreshed at {date}",
			"hideReplies": "***Sapphire Hide Replies",
			"newComment": "***Sapphire New Comment",
			"placeholder": "***Sapphire RE: {title}",
			"refresh": "***Sapphire Refresh",
			"reply": "***Sapphire Reply",
			"showNReplies": "***Sapphire Show {count} replies",
			"showOneReply": "***Sapphire Show 1 reply"
		},
		"ProgressBar": {
			"completed": "***Sapphire {percent}% Completed",
			"inProgress": "***Sapphire {percent}% In Progress"
		},
		"ProgressReportDepartments": {
			"inProgress": "***Sapphire In Progress",
			"noCoursesQualifyRequirementWithPeriod": "***Sapphire No courses currently qualify for this requirement."
		},
		"ProgressReportYears": {
			"schoolYearWithColon": "***Sapphire School Year: {year}"
		},
		"QuestionGroup": {
			"message": "***Sapphire There is additional information for this question."
		},
		"QuestionSummary": {
			"correct": "***Sapphire Correct",
			"incorrect": "***Sapphire Incorrect",
			"is": "***Sapphire is",
			"partiallyCorrect": "***Sapphire Partially Correct",
			"ptsEarned": "***Sapphire pts earned",
			"yourAnswer": "***Sapphire Your answer"
		},
		"ReportFiles": {
			"datePosted": "***Sapphire Date Posted",
			"name": "***Sapphire Name",
			"navPanelLetters": "***Sapphire Letters",
			"navPanelProgressReports": "***Sapphire Progress Reports",
			"navPanelReportsSubMenuLetters": "***Sapphire Reports, Sub-Menu Letters",
			"navPanelReportsSubMenuProgressReports": "***Sapphire Reports, Sub-Menu Progress Reports",
			"navPanelReportsSubMenuReportCards": "***Sapphire Reports, Sub-Menu Report Cards",
			"navPanelReportsSubMenuTranscript": "***Sapphire Reports, Sub-Menu Transcript",
			"navPanelReportCards": "***Sapphire Report Cards",
			"navPanelTranscript": "***Sapphire Transcript",
			"school": "***Sapphire School"
		},
		"Required": {
			"tootTipMessage": "***Sapphire You may only choose {required} course(s) for {description}. You chose {count}"
		},
		"SessionTimeoutModal":{
			"sessionTimeoutModalTitle": "***Sapphire Warning your session is about to end due to inactivity.",
			"sessionTimeoutModalMessage": "***Sapphire You have been idle for to long. <span role='timer' aria-live='polite' aria-atomic='true' aria-label='Time remaining'>You will be logged out in <strong>{remainingTimeInSession} minutes</strong></span> if you do not take an action. Choose below to logout out or remain logged in."
		},
		"ShortFillQuestion": {
			"enterMessage": "***Sapphire Enter your short answer",
			"ptsPossible": "***Sapphire pts possible"
		},
		"SidePanel": {
			"mainNavLabel": "***Sapphire Main",
			"navPanelReports": "***Sapphire Reports",
			"sideMenuCollapseLabel": "***Sapphire Collapse Menu",
			"sideMenuCourseRequestFormLink": "***Sapphire Course Request Form",
			"sideMenuExpandLabel": "***Sapphire Expand Menu",
			"sideMenuMyBackpackHeader": "***Sapphire My Backpack",
			"sideMenuReportsLink": "***Sapphire Reports"
		},
		"StudentCalendar": {
			"day": "***Sapphire day",
			"dueDateTitleCaseWithColon": "***Sapphire Due Date:",
			"list": "***Sapphire list",
			"month": "***Sapphire month",
			"sideMenuStudentCalendarLink": "***Sapphire Student Calendar",
			"startDateTitleCaseWithColon": "***Sapphire Start Date:",
			"today": "***Sapphire today",
			"week": "***Sapphire week"
		},
		"StudentDataForms": {
			"deleteFormMessage": "***Sapphire Are you sure you want to delete this form?",
			"deleteFormOkText": "***Sapphire Delete Form",
			"deleteFormTitle": "***Sapphire Delete Form?",
			"descriptionLabel": "***Sapphire Description",
			"formLabel": "***Sapphire Form",
			"formsAwaitingCompletionTitleCase": "***Sapphire Forms Awaiting Completion",
			"lastSubmittedTitleCase": "***Sapphire Last Submitted",
			"noFormsAwaitingCompletion": "***Sapphire No forms awaiting completion",
			"onDemandFormsTitleCase": "***Sapphire On Demand Forms",
			"openUntilTitleCase": "***Sapphire Open Until",
			"resetFormTitleCase": "***Sapphire Clear Form",
			"sideMenuStudentDataFormsLink": "***Sapphire Student Data Forms",
			"status": "***Sapphire Status",
			"submissionsTitleCase": "***Sapphire Submissions"
		},
		"StudentInformation": {
			"combinationWithColon": "***Sapphire Combination:",
			"counselorWithColon": "***Sapphire Counselor:",
			"homeroomWithColon": "***Sapphire Homeroom:",
			"learningGroup": "***Sapphire Learning Group:",
			"locationWithColon": "***Sapphire Location:",
			"lockerWithColon": "***Sapphire Locker:",
			"sideMenuGradeLabelEnrolled": "***Sapphire {school} - Grade: {grade}",
			"sideMenuGradeLabelNotEnrolled": "***Sapphire {school} - Grade: {grade} - Not Currently Enrolled",
			"sideMenuStudentInformationLink": "***Sapphire Student Information",
			"teacherWithColon": "***Sapphire Teacher:",
			"team": "***Sapphire Team:"
		},
		"Students": {
			"addAnotherStudent": "***Sapphire Add another student",
			"birthdayDatepickerAccessibilityMessage": "***Sapphire Student birthday date picker",
			"birthdayWithColon": "***Sapphire Birthday:",
			"firstNameWithColon": "***Sapphire First Name:",
			"lastNameWithColon": "***Sapphire Last Name:",
			"manageStudentsTitleCase": "***Sapphire Manage Students",
			"portalAccessInformationalText": "***Sapphire If you want to apply to have Portal access to a different student who is already enrolled in the school district, please click on the button below",
			"requestAccessToOterStudents": "***Sapphire Request access to other students",
			"requestAccessToOtherStudentsTitleCase": "***Sapphire Request Access to Other Students",
			"schoolWithColon": "***Sapphire School:",
			"studentHasAnAccount": "***Sapphire Student has an account",
			"students": "***Sapphire Students",
			"studentsDetailOnWhatToEnter": "***Sapphire Enter the name, birth date, grade, and school below for the students you wish to access. A request will be sent to the school district for approval.",
			"submitRequestTitleCase": "***Sapphire Submit Request"
		},
		"Submission": {
			"addSubmission": "***Sapphire Add Submission",
			"assignmentBin": "***Sapphire Assignment Bin",
			"assignmentBinClosed": "***Sapphire *This assignment is currently not open for submissions.",
			"dirtyPageAssignmentMessage": "***Sapphire This assignment have been modified. Are you sure you want to leave without saving changes?",
			"dirtyPageAssignmentTitle": "***Sapphire Unsaved Changes?",
			"dirtyPageAssignmentOkText": "***Sapphire Leave Without Saving",
			"dirtyPageAssignmentCancelText": "***Sapphire Keep Editing",
			"oneFileUpload": "***Sapphire Only one file is allowed to be uploaded",
			"onlyOneSubmission": "***Sapphire *You have reached the limit of 1 submission for this assignments.",
			"submittedFiles": "***Sapphire Submitted Files",
			"textSubmission": "***Sapphire Text Submission",
			"textSubmissionColon": "***Sapphire Text Submission:"
		},
		"testButtons": {
			"takeTester_changeAnswer": "***Sapphire Change Answer",
			"takeTester_flagQuestion": "***Sapphire Flag question",
			"takeTester_saveAnswer": "***Sapphire Save Answer",
			"takeTester_submitTest": "***Sapphire Submit Test"
		},
		"testReviewer": {
			"extraCredit": "***Sapphire Extra Credit",
			"points": "***Sapphire points",
			"reviewMyTest": "***Sapphire Review My Test",
			"scoreOfTotalScore": "***Sapphire {score} of {total}",
			"scoreOfTotalScorePossible": "***Sapphire {score} of {total} possible",
			"scoreOutOfTotal": "***Sapphire {score} / {total}",
			"started": "***Sapphire Started",
			"submitted": "***Sapphire Submitted",
			"takeTester_finishedReview": "***Sapphire When finished reviewing test click the button to close this window."
		},
		"testTaker": {
			"loading": "***Sapphire Loading...",
			"points": "***Sapphire {points} pts.",
			"pointsPossible": "***Sapphire {points} points possible",
			"questionNumber": "***Sapphire Question {number}",
			"takeTester_allowChange": "***Sapphire Students will not be able to change their answers during this test session.",
			"takeTester_availableForReview": "***Sapphire It will be available for reviewing after all tests are graded.",
			"takeTester_closeWindow": "***Sapphire Close Window",
			"takeTester_duration": "***Sapphire Duration",
			"takeTester_immediateFeedback": "***Sapphire Once answers are submitted, feedback will be displayed.",
			"takeTester_mins": "***Sapphire {time} Mins",
			"takeTester_minsLeft": "***Sapphire Minutes Left",
			"takeTester_singleSession": "***Sapphire You must complete this test in a single session",
			"takeTester_startNow": "***Sapphire Start Test Now",
			"takeTester_submitted": "***Sapphire Your test has been submitted!",
			"takeTester_testEndedMessage": "***Sapphire This test has been submitted and you are no longer be able to change any answers.",
			"takeTester_testExpired": "***Sapphire This test is no longer available to be taken.",
			"takeTester_windowCloses": "***Sapphire Window Closes",
			"takeTester_windowOpen": "***Sapphire Window Opens"
		},
		"thirdPartyAccess": {
			"accessGranted": "***Sapphire Access Granted",
			"client": "***Sapphire Client",
			"confirmRevokeAccessMessage": "***Sapphire Are you sure you want to revoke this clients access to your account?",
			"confirmRevokeAccessTitle": "***Sapphire Revoke access?",
			"description": "***Sapphire View all third party apps and services that have been granted access. Use the Revoke Access button to end access for an app or service.",
			"lastUsed": "***Sapphire Last Used",
			"manageThirdPartyAccess": "***Sapphire Manage Third Party Access for Apps and Services",
			"noClientsMessage": "***Sapphire There are currently no third party apps and services with access.",
			"revokeAccess": "***Sapphire Revoke Access",
			"thirdPartyAccess": "***Sapphire Third Party Access"
		},
		"TimeTraveller": {
			"weekOfWithColon": "***Sapphire Week of:",
			"enterCorrectDateFormat": "***Sapphire Enter correct date format of MM/DD/YYYY",
			"datepickerAriaMessage": "***Sapphire Week of date picker, date format of MM/DD/YYYY"
		},
		"trueFalseQuestion": {
			"questionMessage": "***Sapphire Select either True or False"
		}
	}
};
